const createQuery = () => `
  ... on BlockquoteWidget {
    html
    attribution
    buttonText
    buttonLink
  }
`
export default createQuery
